// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export const generateTeamsDeepLink = async (
  url: string,
  userName: string,
  functionsAppToken: string
): Promise<string> => {
  const token = await getDeepLinkToken(functionsAppToken);
  const deepLinkPath = `acsui://calling/?acstoken=${token}&name=${userName}&teamsurl=${encodeURIComponent(url)}`;
  return deepLinkPath;
};

export const generateACSDeepLink = async (
  groupId: string,
  userName: string,
  functionsAppToken: string
): Promise<string> => {
  const token = await getDeepLinkToken(functionsAppToken);
  const deepLinkPath = `acsui://calling/?acstoken=${token}&name=${userName}&groupid=${groupId}`;
  return deepLinkPath;
};

const getDeepLinkToken = async (functionsAppToken: string): Promise<string> => {
  const userTokenResponse = await fetch('api/token', {
    headers: new Headers({
      Authorization: `Bearer ${functionsAppToken}`
    })
  });
  const userTokenResponseJson = await userTokenResponse.json();
  const token = userTokenResponseJson.userAndToken.token;
  return token;
};

export const openDeepLinkInNewWindow = (deepLinkPath: string): void => {
  const newWindow = window.open('', '_top');
  if (newWindow) {
    newWindow.location.href = deepLinkPath;
  }
};
